// What a click on a results row means. Shared by the row handlers in
// ResultsTable so the "open in a new tab" rules (middle button, Ctrl/Cmd+click)
// and the "clicks on controls keep their own behavior" guard are one decision,
// not three copies.

/** Controls inside a row that own their clicks: links, buttons, checkboxes. */
export const ROW_CONTROL_SELECTOR = 'a, button, input, label, [role="button"]';

/** True when the event landed on a control rather than the row itself. */
export const hitsRowControl = (event) =>
  Boolean(event?.target?.closest && event.target.closest(ROW_CONTROL_SELECTOR));

/** Middle mouse button (auxclick / mousedown button 1). */
export const isMiddleButton = (event) => event?.button === 1;

/** Ctrl+click (Cmd+click on a Mac) — the browser's own "open in a new tab". */
export const wantsNewTab = (event) => Boolean(event && (event.ctrlKey || event.metaKey));

/**
 * A router path as a real URL for window.open: the router's basename
 * ("/NotesAI" locally, "" when none) plus the path. useHref("/") yields the
 * basename with a trailing slash, which is stripped so paths join cleanly.
 */
export const newTabHref = (rootHref, to) => `${String(rootHref || "").replace(/\/$/, "")}${to}`;
